import React from 'react';
import { SubWindow } from '@starflow/app/components/common/Window';
import { getTempState, useTempState } from '@starflow/app/store';
import { convert2CompressedUrl } from '@shakkerai/util-image';

const VideoPlayerInner = React.memo((props) => {
  const { data } = props;

  return (
    <div className="w-[640px] h-[480px] bg-black">
      <video
        controls
        autoPlay={false}
        src={data.videoUrl}
        poster={convert2CompressedUrl(data.coverUrl, 1000)}
        className="w-full h-full"
      />
    </div>
  );
});

export const VideoPlayerWindow = React.memo(() => {
  const exclusiveWindow = useTempState('exclusiveWindow');
  if (exclusiveWindow !== 'video-player') return null;

  const videoData = getTempState('videoPlayerData');
  if (!videoData?.videoUrl) return null;

  return (
    <SubWindow width={640} height={524} title="播放视频" name="video-player" className="w-[640px] h-[524px]">
      <VideoPlayerInner data={videoData} />
    </SubWindow>
  );
});
